import { render, staticRenderFns } from "./SelectSource.vue?vue&type=template&id=37dff556&"
import script from "./SelectSource.vue?vue&type=script&lang=js&"
export * from "./SelectSource.vue?vue&type=script&lang=js&"
import style0 from "./SelectSource.vue?vue&type=style&index=0&id=37dff556&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports